// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AddDeductionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_AddDeductionResponseDados {
deduction_id: number
}

export type Payroll_AddDeductionResponse = ApiResponse<Payroll_AddDeductionResponseDados>;

registerResponseContract('Payroll_AddDeductionResponse', {
  deduction_id: { type: 'number',  required: true },
})
